export * from './LojaServiceAdapter'